var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9176 19.9912L21.2763 22.7507C21.2189 22.8107 21.1494 22.8585 21.0722 22.8911C20.995 22.9238 20.9118 22.9406 20.8276 22.9406H8.30663C8.24689 22.9406 8.18845 22.9236 8.13849 22.8917C8.08853 22.8597 8.04923 22.8143 8.02541 22.7609C8.0016 22.7076 7.99431 22.6486 8.00444 22.5912C8.01457 22.5338 8.04168 22.4806 8.08244 22.4381L10.7257 19.6785C10.783 19.6187 10.8522 19.571 10.9292 19.5384C11.0061 19.5057 11.0891 19.4888 11.1731 19.4886H23.6934C23.7531 19.4886 23.8115 19.5056 23.8615 19.5375C23.9114 19.5695 23.9507 19.6149 23.9746 19.6683C23.9984 19.7217 24.0057 19.7807 23.9956 19.838C23.9854 19.8954 23.9583 19.9486 23.9176 19.9912ZM21.2763 14.4342C21.2189 14.3742 21.1494 14.3264 21.0722 14.2938C20.995 14.2611 20.9118 14.2443 20.8276 14.2443H8.30663C8.24689 14.2443 8.18845 14.2613 8.13849 14.2932C8.08853 14.3252 8.04923 14.3706 8.02541 14.424C8.0016 14.4774 7.99431 14.5363 8.00444 14.5937C8.01457 14.6511 8.04168 14.7043 8.08244 14.7468L10.7257 17.5064C10.783 17.5662 10.8522 17.6139 10.9292 17.6466C11.0061 17.6792 11.0891 17.6961 11.1731 17.6963H23.6934C23.7531 17.6963 23.8115 17.6793 23.8615 17.6473C23.9114 17.6154 23.9507 17.57 23.9746 17.5166C23.9984 17.4632 24.0057 17.4042 23.9956 17.3469C23.9854 17.2895 23.9583 17.2363 23.9176 17.1937L21.2763 14.4342ZM8.30663 12.452H20.8276C20.9118 12.452 20.995 12.4352 21.0722 12.4025C21.1494 12.3698 21.2189 12.322 21.2763 12.2621L23.9176 9.50252C23.9583 9.45997 23.9854 9.40675 23.9956 9.34939C24.0057 9.29203 23.9984 9.23303 23.9746 9.17966C23.9507 9.12628 23.9114 9.08084 23.8615 9.04892C23.8115 9.01701 23.7531 9 23.6934 9H11.1731C11.0891 9.00014 11.0061 9.01706 10.9292 9.04972C10.8522 9.08238 10.783 9.13007 10.7257 9.18986L8.08312 11.9494C8.0424 11.9919 8.01531 12.0451 8.00515 12.1024C7.995 12.1597 8.00223 12.2186 8.02596 12.272C8.04969 12.3254 8.08888 12.3708 8.13874 12.4028C8.1886 12.4347 8.24695 12.4518 8.30663 12.452Z",
    fill: "url(#paint0_linear_1187_29475)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1187_29475",
    x1: 9.35059,
    y1: 23.2728,
    x2: 22.0979,
    y2: 8.52218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.281fde090446c04c5ae7ab7d6acb53bd.svg";
export { ForwardRef as ReactComponent };